<!-- routes/Privacy.svelte -->
<script>
  import Privacy from '../components/Privacy.svelte'
</script>


<div>
  <Privacy />
</div>
